import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from "@apollo/client";

// Creează un link personalizat care elimină __typename
const link = ApolloLink.from([
  new ApolloLink((operation, forward) => {
    // Elimină __typename din variabilele de query
    operation.variables = {
      ...operation.variables,
      __typename: undefined,
    };
    return forward(operation);
  }),
  new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
  }), // link-ul standard HTTP
]);

const client = new ApolloClient({
  link, // folosește link-ul personalizat
  cache: new InMemoryCache(),
});

export default client;
